var map = {
	"./HRDocPortalEmbeddable.js": "./src/embeddables/HRDocPortalEmbeddable.js",
	"./OAuthTokenEmbeddable.js": "./src/embeddables/OAuthTokenEmbeddable.js",
	"./TrackedMailEmbeddable.js": "./src/embeddables/TrackedMailEmbeddable.js",
	"./TrackedMailEventEmbeddable.js": "./src/embeddables/TrackedMailEventEmbeddable.js",
	"./TrackedPostmailEmbeddable.js": "./src/embeddables/TrackedPostmailEmbeddable.js",
	"./TrackedPostmailEventEmbeddable.js": "./src/embeddables/TrackedPostmailEventEmbeddable.js",
	"./TrackedSmsEmbeddable.js": "./src/embeddables/TrackedSmsEmbeddable.js",
	"./TrackedSmsEventEmbeddable.js": "./src/embeddables/TrackedSmsEventEmbeddable.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/embeddables sync recursive ^\\.\\/.*\\.js$";